import { Button, Modal } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { logout } from '../features/authSlice.js'; // Assuming this is your logout function
import { useDispatch } from 'react-redux';
import { menucontrol } from '../features/togglebuttonSlice.js';

export default function AuthModal({ handleAuthModalClose }) {
  const [openModal, setOpenModal] = useState(true);
  const [remainingTime, setRemainingTime] = useState(30); // Initial countdown time
   const dispatch = useDispatch();
  const handleCloseModal = useCallback(() => {
    setOpenModal(false);
    handleAuthModalClose();
  }, [handleAuthModalClose]);

  // Timer functionality:
  useEffect(() => {
    const timerId = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime((prevTime) => prevTime - 1);
      } else {
        logout(); // Logout user after timeout
        localStorage.setItem('isHome', true);
        dispatch(menucontrol(true));
        window.location.href = '/donorLogin';
      }
    }, 1000); // Update timer every second

    return () => clearInterval(timerId);
  }, [remainingTime]); /* Remove empty dependency array */

  return (
    <div>
      {/* <Button onClick={() => setOpenModal(true)}>Toggle Modal</Button> */}
      <Modal className="bg-transparent mx-auto max-w-sm" show={openModal} onClose={handleCloseModal}>
        <Modal.Header className="flex items-center justify-between">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Session Expiring</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v-4m0 16v-4m0 8v-8" />
          </svg>
        </Modal.Header>
        <Modal.Body className="text-base leading-relaxed">
          <div className="flex items-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-red-500 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v-4m0 16v-4m0 8v-8zM21 12c0 5-3 9-9 9-1 0-2-.1-3-.2l-1-1c-1.9-.6-3-.9-4-1.4L4 10v6a9 9 0 0 0 9 9 1 1 0 0 1 1-1z"
              />
            </svg>
            <p>Your session will expire in {remainingTime} seconds.</p>
          </div>
          <p>Warning: If you do not refresh, you will be automatically logged out.</p>
        </Modal.Body>
        <Modal.Footer className="flex justify-end">
          <Button className="red-btn" onClick={handleCloseModal}>
            Refresh Token
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h16V4zM4 14v5h16V14z" />
            </svg>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
